import { render } from "./SignUpButton.vue?vue&type=template&id=60fc59b4"
import script from "./SignUpButton.vue?vue&type=script&lang=js"
export * from "./SignUpButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__